<template>
  <div id="LoanCardex">
    <loading v-if="loadingRender"></loading>
    <panel
      :Title="$cookies.get('IsAnbohSaz')=='false' ? (FilterMoavaghe && FilterMoavaghe == true ? 'جزئیات معوقات' : 'کاردکس تسهیلات') : FilterMoavaghe && FilterMoavaghe == true ? 'جزئیات معوقات' : 'کاردکس قرارداد'"
      :Des="$cookies.get('IsAnbohSaz')=='false' ? 'از طریق این فرم میتوانید کاردکس تسهیلات خود را مشاهده نمائید' : ''"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row">
      <!-- <div class="col-12 bg-warning">
        <button @click="testAxios()" class="btn btn-danger"> TestAPI Services </button>
      </div> -->
      <div v-if="!FilterMoavaghe" class="card p-3 m-3 border rounded Netpa-Shadow w-100" id="Date">
        <div class="row">
          <span class="alert alert-dark text-center w-100 p-2 m-2">{{ $cookies.get('IsAnbohSaz')=='false' ? 'لطفا تسهیلات خود را' : 'لطفا قرارداد خود را' }} <span class="text-success">انتخاب</span> نمایید</span>
        </div>
        <div class="row">
          <div class="col-md-4 col-12 mt-2 text-right">
            <small>{{ $cookies.get('IsAnbohSaz')=='false' ? 'انتخاب تسهیلات' : 'انتخاب قرارداد' }}</small>
            <select v-if="IsLoad" name="cmbTaahodat" @change="getCardex" id="cmbTaahodat" class="form-control Pointer" v-model="Resultcmb">
              <option selected value="-1">-- {{ $cookies.get('IsAnbohSaz')=='false' ? 'انتخاب تسهیلات' : 'انتخاب قرارداد' }} --</option>
              <option v-for="item in this.ListModel" :id="item.id" :key="item.id" :value="item.id">
                <span>{{ item.vcodeDesNo }} </span>
                <span>{{ item.nameFamily }} </span>
              </option>
            </select>
          </div>
          <div class="col-md-2 col-12 mt-3">
            <input
              type="button"
              name=""
              value="جستجو"
              class="btn btn-success mt-2 w-100 d-none"
              @click="
                getCmbCardex()
                $ResetTimer()
              "
            />
          </div>
          <div class="col-5"></div>
         <div class="col-1">
          <button class="btn btn-outline-danger" @click="GetPdf">
            خروجی PDF
          </button>
         </div>
        </div>
      </div>
    </div>
    <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config" :classes="classes" id="Data">
      <template slot="sort-asc-icon">
        <i class="fa fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fa fa-sort"></i>
      </template>
      <template slot="empty-results">
        <p class="text-right">اطلاعاتی یافت نشد</p>
      </template>
      <template slot="Pay" slot-scope="props">
        <!-- <i class="fas fa-cart-plus hover-success Pointer text-secondary"></i> -->
        <small v-if="Number(props.row.mandeGhest.replace(/,/g, '').replace(/\./g, ''))>0" class="badge border border-secondary text-dark px-3 py-1 Pointer hover-danger" @click="AddToCart(props.row, false)"><i class="fas fa-plus ml-2"></i>افزودن به لیست پرداخت </small>
      </template>
      <template slot="vaziatGhesttxt" slot-scope="props">
        <small v-if="props.cell_value == 'پرداخت نشده'" class="text-primary">
          <i class="fas fa-times-circle"></i>
          {{ props.cell_value }}
        </small>
        <small v-else-if="props.cell_value == 'سررسيد قسط'" class="text-info">
          <i class="fas fa-user-clock" style="font-size: 13px"></i>
          {{ props.cell_value }}
        </small>
        <small v-else-if="props.cell_value == 'پرداخت نشده ديركرد'" class="text-danger">
          <i class="fas fa-hourglass-half"></i>
          {{ props.cell_value }}
        </small>
        <small v-else-if="props.cell_value == 'زودتر پرداخت شده'" class="text-success">
          <i class="fas fa-check-circle"></i>
          {{ props.cell_value }}
        </small>
        <small v-else-if="props.cell_value == 'به موقع پرداخت شده'" class="text-success">
          <i class="fas fa-user-clock" style="font-size: 13px"></i>
          {{ props.cell_value }}
        </small>
        <small v-else-if="props.cell_value == 'ديرتر پرداخت شده'" class="text-warning">
          <i class="fas fa-check-circle" style="color: #67b221"></i>
          {{ props.cell_value }}
        </small>
      </template>
    </vue-bootstrap4-table>
    
  </div>
</template>
<script>
import panel from '../Tools/NetPa/Panel.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import loading from '../Tools/NetPa/Loading.vue'
import html2pdf from 'html2pdf.js'

export default {
  data() {
    return {
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'LoanCardex',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_cmbTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/TaahodatSahebHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      ListModel: null,
      IsLoad: false,
      Resultcmb: '-1',
      rows: [],
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },
        {
          label: 'تاریخ سررسید',
          name: 'tarixGhest',
        },
        {
          label: 'مبلغ قسط(ريال)',
          name: 'mablaghGhest',
        },
        {
          label: 'مبلغ پرداختی(ريال)',
          name: 'mabPardaxtShodeGhest',
        },
        {
          label: 'مانده قسط',
          name: 'mandeGhest',
        },
        {
          label: 'تاریخ پرداخت',
          name: 'tarixSanad',
          sort: true, // "false" by default
        },
        {
          label: 'وضعیت',
          name: 'vaziatGhesttxt',
        },
        {
          label: 'جریمه(ريال)',
          name: 'mabJarime',
          visibility: this.$session.get('CustCode') == 868 ? false : true,
        },
        {
          label: 'پرداخت',
          name: 'Pay',
          visibility: this.$cookies.get('CardexPay') == 'true' ? true : false,
        },
        {
          label: 'vaziatGhest',
          name: 'vaziatGhest',
          visibility: false,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },
      loadingRender: false,
      ListModelSahebHesab: null,
      mablaghKarmozd1: 0,
      mablaghKarmozd2: 0,
      mandeGhest: 0,
      TaahodatRow :null
    }
  },
  components: {
    panel,
    VueBootstrap4Table,
    loading,
  },
  mounted() {
    this.$AutoCloseMenuForMobile()

    window.scrollTo(0, 0)
    const formData = new FormData()
    let info
    formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
    formData.append('wwwtblSarfaslTypeId', 1)
    this.DataAxios_cmbTaahodat.ArryfildValue = formData
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
        this.IsLoad = true
        this.ListModel = data.filter((x) => x.mande > 0)
        this.Resultcmb = !this.TaahodatId ? this.ListModel[0].id : this.TaahodatId
        this.TaahodatRow=this.ListModel.find(x => x.id==this.Resultcmb)
        
        this.getCmbCardex()
      })
      .finally(() => {
        const formData = new FormData()
        formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
        formData.append('wwwtblSarfaslTypeId', 1)
        this.DataAxios_SahebHesab.ArryfildValue = formData
        this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
          if (data.length > 0) {
            this.IsLoad = true
            this.ListModelSahebHesab = data
            for (let index = 0; index < this.ListModelSahebHesab.length; index++) {
              if (this.ListModelSahebHesab[index].mande > 0) {
                info = this.ListModelSahebHesab[index]
                this.ListModel.push(info)
              }
            }
          }
        })
      })
  },
  methods: {
    AddToCart(row, IsAccount) {
      console.log("😂 ~ file: LoanCardex.vue:241 ~ row:", row.tarixGhest)
      if (Number(row.mandeGhest.replace(/,/g, '').replace(/\./g, ''))>0) {
        this.TaahodatRow['SumGhabelPar']=Number(row.mandeGhest.replace(/,/g, '').replace(/\./g, ''))
        this.$Netpa_AddToCart(this.TaahodatRow, 'Loan', 'کاردکس',true)
      }
      else{
        this.$mySweetDefaultTost('عدم افزودن به لیست', 'قسط انتخابی شما پرداخت گردیده و امکان اضافه شدن به لیست پرداخت وجود ندارد', 'warning', 3000)
      }
    },
    getCmbCardex() {
      if (this.Resultcmb > 0) {
        this.loadingRender = true
        const formData = new FormData()
        formData.append('TaahodatId', this.Resultcmb)
        formData.append('ShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId)
        this.DataAxiosRow.ArryfildValue = formData

        this.$PostFormData(this.DataAxiosRow).then((data) => {
          if (data.status == 'Ok') {
            let info
            let list = []

            if (typeof data == 'string') {
              data = JSON.parse(data)
              for (let index = 0; index < data.length; index++) {
                var element = data[index]
                for (var key in element) {
                  var temp = JSON.parse(JSON.stringify(key))
                  var newkey = temp.charAt(0).toLowerCase() + temp.slice(1)
                  element[newkey] = element[key]
                  element['row'] = index + 1
                  delete element[key]
                }
              }
            }

            for (let index = 0; index < data.result.length; index++) {
              info = data.result[index]
              info['row'] = index + 1
              list.push(info)
            }
            this.rows = this.$FormatMablaghGrid(list)
            if (this.FilterMoavaghe && this.FilterMoavaghe == true) {
              //
              // vaziatGhest==2   DirKard
              //vaziatGhest==5 Dirtar PardakhtShode
              this.rows = this.rows.filter((x) => Number(x.mandeGhest.replace(/,/g, '').replace(/\./g, '')) > 0 && (x.vaziatGhest == 2 || x.vaziatGhest == 5))
            }
            this.loadingRender = false
          } else {
            this.$mySweetDefaultTost('عدم وجود اطلاعات', 'اطلاعاتی یافت نشد ، فیلتر جستجوی خود را تغییر دهید', 'warning', 2000)
            this.config.pagination = false
            this.rows = []
            this.loadingRender = false
          }
        })
        // }else{
        //   this.getCardexFromApiService(this.taahodatId);
        // }
      }
    },
    getCardex() {
      // if(ApiServiceUrl == ""){
      this.getCmbCardex()
      // }else{
      //   this.getCardexFromApiService(null)
      // }
    },
    getCardexFromApiService(inputTId) {
      var data = {
        prm: [inputTId == null ? this.Resultcmb : inputTId],
        IsDataTable: false,
      }

      this.$PostDataAPISERVICE({
        ArryfildValue: data,
        Token: this.$session.get('TokenNetPa'),
      })
        .then((data) => {
          for (let index = 0; index < data.length; index++) {
            var element = data[index]
            for (var key in element) {
              var temp = JSON.parse(JSON.stringify(key))
              var newkey = temp.charAt(0).toLowerCase() + temp.slice(1)
              element[newkey] = element[key]
              element['row'] = index + 1
              delete element[key]
            }
          }

          this.rows = this.$FormatMablaghGrid(data)
        })
        .finally(() => {
          this.loadingRender = false
        })
    },
    GetPdf(){
      this.loadingRender=true
      this.columns[9].visibility=false;
      var htmlObject = document.getElementById('Data');
      // htmlObject.innerHTML = html
      html2pdf(htmlObject, {
        jsPDF: { format: 'a4', orientation: 'portrait' },
      })
      const myTimeout = setTimeout(this.Reload, 2000)
    },
    Reload(){
      this.loadingRender=false
      this.columns[9].visibility=true;
    }
  },
  created() {
    if (this.wwwtblAzaId) {
      this.$session.set('UserFromLoan', [this.wwwtblAzaId, false])
    }
  },
  props: ['TaahodatId', 'wwwtblAzaId', 'FilterMoavaghe'],
}
</script>
<style scoped></style>
